import React from "react";
import {
  Box,
  InputBase,
  Paper,
  Tooltip,
  styled,
  IconButton,
  Stepper,
} from "@mui/material";

import {
  SecondaryButton,
  PrimaryButton,
} from "../../../components/StyledComponents/Buttons/AuradineButtons.js";

import AddIcon from "@mui/icons-material/Add";
import { useHistory, Link } from "react-router-dom";
import { Search as SearchIcon } from "@mui/icons-material";
import usePriceConfigurationContext from "../../context/usePriceConfigurationContext.js";
import AddPriceConfigDialog from "../AddPriceConfigDialog/AddPriceConfigDialog.js";
import { set } from "date-fns";
import { isEmpty } from "lodash";
import { useTheme } from "../../../ThemeContext/ThemeContext.js";
import { StyledIconButton } from "../../../components/StyledComponents/Buttons/AuradineButtons.js";
export const PriceConfigurationHeader = React.memo(
  (props) => {
    const { refetch, userRole, totalCount, data } = props;
    const history = useHistory();
    const { colors } = useTheme();
    const {
      setOpenAddPriceConfigModal,
      setPriceConfigData,
      priceConfigData,
      priceConfigDataCopy,
      setSiteConfigurationDataToEdit,
    } = usePriceConfigurationContext();
    console.log(data, "actualData in header");

    const filterData = (event) => {
      const searchValue = event.target.value.toLowerCase();
      if (searchValue) {
        const filteredData =
          priceConfigDataCopy &&
          priceConfigDataCopy.filter((data) =>
            data.priceConfigName
              ?.toLowerCase()
              .includes(searchValue)
          );
        setPriceConfigData(filteredData);
      } else {
        setPriceConfigData(priceConfigDataCopy);
      }
    };

    return (
      <Box
        className={"table-container-header"}
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"flex-start"}
          alignItems={"center"}
        >
          {data &&
            data.status === "ok" &&
            data.result &&
            data.result.priceConfig &&
            !isEmpty(data.result.priceConfig) &&
            Object.entries(data.result.priceConfig).length >
              0 && (
              <Paper
                component="form"
                elevation={0}
                sx={{
                  p: "2px 4px",
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  backgroundColor: colors?.background?.secondary,
                  borderRadius: "1.75rem",
                  paddingLeft: "1rem",
                }}
              >
                <Tooltip
                  // title={searchValue}
                  disableFocusListener
                  disableTouchListener
                >
                  <InputBase
                    sx={{ flex: 1, minWidth: "22.5rem", color: colors?.text?.primary }}
                    placeholder="Search for a price configuration"
                    onChange={(event) => {
                      filterData(event);
                    }}
                    inputProps={{
                      "aria-label": "search google maps",
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                      }
                    }}
                  />
                </Tooltip>
                <StyledIconButton colors={colors}
                  type="button"
                  sx={{ p: "10px" }}
                  aria-label="search"
                >
                  <SearchIcon />
                </StyledIconButton>
              </Paper>
            )}
        </Box>
        <Box display={"flex"} flexDirection={"row"} gap={2}>
          <Box
            className={"action-container"}
            display={"flex"}
            flexDirection={"row"}
            gap={2}
          >
              <SecondaryButton colors={colors}
                onClick={() => {
                  history.push("/jobresults?command=fvmode&timeRange=last_2_min");
                  try {
                    const storageToClear = [
                      "command",
                      "mode",
                      "tune",
                      "powercurtail",
                      "timeRange",
                      "status",
                      "eventType",
                      "search",
                    ];
                    storageToClear.forEach((key) => {
                      sessionStorage.removeItem(key);
                    });
                    sessionStorage.setItem("timeRange", JSON.stringify("last_2_min"));
                    sessionStorage.setItem("command", JSON.stringify(["fvmode"]));
                  } catch (e) {
                    console.error("Failed to update sessionStorage:", e);
                  }
                }}
              >
                Recent price config jobs
              </SecondaryButton>
              <PrimaryButton colors={colors}
                disabled={
                  userRole === "user" ||
                  Number(totalCount) >= 32
                }
                onClick={() => {
                  setOpenAddPriceConfigModal(true);
                  setSiteConfigurationDataToEdit({});
                }}
              >
                Add <AddIcon />
              </PrimaryButton>
          </Box>
        </Box>
        <AddPriceConfigDialog refetch={refetch} />
      </Box>
    );
  }
);
